import api from './api';

export interface SucVenta {
    nroSuc: number;
    nroTipoFormulario: string;
    formuA?: number;
    formuB?: number;
    formuC?: number;
    formuN?: number;
    numPropio?: string;
    nroTipoFormularioNumerador?: string;
    copias?: number;
    renglones?: number;
    plantiA?: string;
    plantiB?: string;
    plantiC?: string;
    plantiN?: string;
    plantiComun?: string;
    impA?: string;
    impB?: string;
    impC?: string;
    impN?: string;
    impComun?: string;
    vpreviaA: string;
    vpreviaB: string;
    vpreviaC: string;
    vpreviaN: string;
    vpreviaComun: string;
    imprime: string;
    liquidaComision: string;
    afectaLimCred?: string;
    actualizaLimCred?: string;
    tipoImpresora?: string;
    usaCodigoBarra?: number;
    tipoRenglones?: string;
    idWsfe?: string;
    generaRemito: string;
    nroSucRemito?: number;
    soloAdvertencia?: number;
    usaLetraM?: number;
    idWsfecred?: string;
    passEmision?: string;
    passAnulacion?: string;
    generaOcarga: string;
    nroSucOcarga?: number;
    tipoFormulario?: any;
    nombreSucursal?: string;
}

export interface SucVentaSearchParams {
    searchTerm?: string;
    pageNumber: number;
    pageSize: number;
    nroSuc?: number;
    nroTipoFormulario?: string;
}

export interface SucVentaPagedResult {
    items: SucVenta[];
    totalCount: number;
    pageNumber: number;
    pageSize: number;
    totalPages: number;
}

const sucVentaService = {
    getSucVentas: async (params: SucVentaSearchParams): Promise<SucVentaPagedResult> => {
        const queryParams: Record<string, string | number | undefined> = {
            PageNumber: params.pageNumber,
            PageSize: params.pageSize,
            SearchTerm: params.searchTerm || undefined
        };
        if (params.nroSuc != null) queryParams.NroSuc = params.nroSuc;
        if (params.nroTipoFormulario != null) queryParams.NroTipoFormulario = params.nroTipoFormulario;
        const response = await api.get<SucVentaPagedResult>('/api/SucVenta', { params: queryParams });
        return response.data;
    },

    getSucVenta: async (nroSuc: number, nroTipoFormulario: string): Promise<SucVenta> => {
        const response = await api.get<SucVenta>(`/api/SucVenta/${nroSuc}/${nroTipoFormulario}`);
        return response.data;
    },

    createSucVenta: async (sucVenta: SucVenta): Promise<SucVenta> => {
        const response = await api.post<SucVenta>('/api/SucVenta', sucVenta);
        return response.data;
    },

    updateSucVenta: async (nroSuc: number, nroTipoFormulario: string, sucVenta: SucVenta): Promise<void> => {
        await api.put(`/api/SucVenta/${nroSuc}/${nroTipoFormulario}`, sucVenta);
    },

    deleteSucVenta: async (nroSuc: number, nroTipoFormulario: string): Promise<void> => {
        await api.delete(`/api/SucVenta/${nroSuc}/${nroTipoFormulario}`);
    }
};

export default sucVentaService;
